import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { api_base_url } from 'src/app/shared/api/api_url';

export interface LegalInfo {
  message: string;
  subtitle: string;
  tipo_pagina: number;
  title: string;
}

@Injectable({
  providedIn: 'root'
})
export class LegalService {
  private apiUrl = 'https://test-api.mytidy.it/api/Resource/Legal';

  constructor(private http: HttpClient) {}

private getBusinessHeader() {
  const token = localStorage.getItem('public_token');
  return {
    'Authorization': `Bearer ${token || ''}`
  };
}

   getBoxInformazioni() {
  return this.http.get<any>(api_base_url + `Legal/3`, {
    headers: this.getBusinessHeader()
  });
}
}
